// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, DispatchBeginLoadCart, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { nullPage } from "@insite/client-framework/Store/Data/Pages/PagesState";

export const XngPopulateApiParameter: typeof PopulateApiParameter = props => {
    const cartSettings = props.getState().context.settings.settingsCollection.cartSettings;

    /**
     * XNG-Changes
     * Always include timestamp to ensure fresh data
    */
    const timestamp = `${new Date().getTime()}`;
    const baseExpands = [...(props.apiParameter.expand || []), timestamp];

    if (!props.needFullCart) {
        const expands = new Set([
            ...baseExpands,
            "cartLines",
            "restrictions",
        ] as typeof props.apiParameter.expand);

        /**
         * XNG-Changes
         * When the showTaxAndShipping setting is disabled, there's no need to request shipping information in the MiniCart. However, if it's enabled, we need to include "tax" so that the tax data is available when navigating to the cart or checkout without requiring an additional request.
         */
        if (!cartSettings.showTaxAndShipping) {
            expands.delete("shipping");
        } else {
            expands.add("tax");
        }

        /**
         * TODO - XNG
         * XNG-Changes
         * If the project enables costCode, make sure to add it.
         */
        // expands.add("costCodes");

        props.apiParameter.expand = [...expands];
    } else {
        /**
         * XNG-Changes:
         * Add custom expand to include `shipTos` for checkout (custom feature for Steiner).
         * `shipTos` is needed to support changing shipping addresses during checkout.
         */
        const expands = new Set([
            ...baseExpands,
            "shipTos",
        ] as typeof props.apiParameter.expand);
        props.apiParameter.expand = [...expands];
    }
};


addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
